import React, { useEffect, useMemo, useState } from "react";
import styles from "./Sites.module.scss";
import { ToastContainer } from "react-toastify";

import storeMenu from "../../../stores";
import {
  MRT_ColumnDef,
  MRT_ShowHideColumnsButton as MrtShowHideColumnsButton,
  MRT_ToggleDensePaddingButton as MrtToggleDensePaddingButton,
  MRT_ToggleFiltersButton as MrtToggleFiltersButton,
  MRT_ToggleFullScreenButton as MrtToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton as MrtToggleGlobalFilterButton,
  MaterialReactTable,
} from "material-react-table";
import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  handleLogOutGlobal_PPE,
  notify,
} from "../../../services/functions";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Box, Button } from "@mui/material";

import {
  AdUnitsRounded,
  ControlPointRounded,
  DeleteForever,
  ModeEdit,
  Refresh,
} from "@mui/icons-material";
import { format } from "date-fns";

import ModalImportDevice from "../../modal/ImportDevice";
import ModalPairDevice from "../../modal/PairDevice";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type Sites = {
  name: string;
  created_at: number;
  created_at_format: string;
  created_by: number;
  updated_at: number;
  updated_at_format: string;
  updated_by: number;
  id: number;
};

type Device = {
  id: number;
  id_device: string;
  expired_at: string;
  id_user: number;
  name: string;
};

const ListDevice = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("Create"); // title modal (eg. Create user)
  const [modalStatus, setModalStatus] = useState(""); // status modal (eg. create / edit)
  const [modalRow, setModalRow] = useState({}); // data parsing for edit
  const [modalLoader, setModalLoader] = useState(true);

  const [showProgressBars, setShowProgressBars] = useState(true);
  const [showSkeleton, setShowSkeleton] = useState(true);

  const [rowList, setRowList] = useState<Device[]>([]);

  const [initialRender, setInitialRender] = useState(true);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });

  const [showPairModal, setShowPairModal] = useState(false);
  const [, setPairIdDevice] = useState("");
  const [, setPairName] = useState("");

  const [userOptions, setUserOptions] = useState<
    { id: number; name: string }[]
  >([]);

  const fetchUserList = async () => {
    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/users/list?limit=100&offset=0`;

    console.log("🔐 Fetching users for device pairing...");

    try {
      const res = await PPE_getApiSync(
        apiUrl,
        null,
        "application/json",
        "GET",
        token,
      );

      console.log("📥 Users response:", res);

      if (res && res.statusCode) {
        console.error("❌ Failed to fetch users:", res);
        return;
      }

      if (Array.isArray(res)) {
        const formatted = res.map((u) => ({ id: u.id, name: u.name }));
        setUserOptions(formatted);
        console.log("✅ Users loaded for pairing:", formatted.length, "users");
      } else {
        console.warn("⚠️ Unexpected users response format:", res);
      }
    } catch (error) {
      console.error("❌ Failed to fetch users:", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowProgressBars(false);
      setShowSkeleton(false);
    }, 1000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      storeMenu.dispatch({ type: "titleicon", text: "Device" });

      // dispatch breadcrumb path
      storeMenu.dispatch({
        type: "breadcrumbs",
        text: [
          { key: "Settings", value: "Setting" },
          { key: "Sites", value: "Device" },
        ],
      });
    }, 100);

    console.log(modalRow);
  }, [showModal, modalRow]);

  useEffect(() => {
    setTimeout(() => {
      fetchUserList();
      getDataList();
    }, 150);
  }, []);

  useEffect(() => {
    if (!initialRender) {
      console.log(JSON.stringify(pagination));
    } else {
      setInitialRender(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  let columns = useMemo<MRT_ColumnDef<Device>[]>(
    () => [
      {
        accessorKey: "id_user",
        header: "User ID",
        size: 300,
      },
      {
        accessorKey: "id_device",
        header: "Device ID",
        size: 400,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 400,
      },
      {
        accessorKey: "expired_at",
        header: "Expired At",
        size: 400,
        Cell: ({ cell }) => {
          try {
            const dateValue = cell.getValue() as string;
            if (!dateValue) return "-";

            // Parse the ISO string date and format it as yyyy-mm-dd
            return format(new Date(dateValue), "yyyy-MM-dd");
          } catch (e) {
            console.error("Error formatting date:", e);
            return cell.getValue() as string;
          }
        },
      },
    ],
    [],
  );

  const getDataList = () => {
    setShowProgressBars(true);
    setShowSkeleton(true);

    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/devices/list?limit=1000&offset=0`;

    console.log(
      "🔐 Token used for API request List Devices:",
      token ? "Token exists" : "No token",
    );
    console.log("🌐 API URL:", apiUrl);

    // Check if token is valid
    if (!token || token.length < 10) {
      console.error("❌ Invalid or missing token");
      notify(
        "error",
        "Invalid or missing authentication token. Please login again.",
        "TOP_CENTER",
      );
      setShowProgressBars(false);
      setShowSkeleton(false);
      window.location.href = "/login";
      return;
    }

    PPE_getApiSync(apiUrl, null, "application/json", "GET", token)
      .then((response) => {
        setTimeout(() => {
          setShowProgressBars(false);
          setShowSkeleton(false);
        }, 77);

        console.log("📥 Raw API Response:", response);
        console.log("📥 Response type:", typeof response);
        console.log("📥 Is Array:", Array.isArray(response));

        // Check if response has error
        if (response && response.statusCode) {
          console.error("API Error:", response);

          // Handle specific error codes
          if (response.statusCode === "403") {
            notify(
              "error",
              "Access denied. You don't have permission to view devices.",
              "TOP_CENTER",
            );
          } else if (response.statusCode === "401") {
            notify(
              "error",
              "Authentication failed. Please login again.",
              "TOP_CENTER",
            );
            setTimeout(() => {
              window.location.href = "/login";
            }, 2000);
          } else {
            notify(
              "error",
              response.msg || "Failed to fetch devices.",
              "TOP_CENTER",
            );
          }

          setRowList([]);
          return;
        }

        if (Array.isArray(response)) {
          console.log(
            "✅ Devices data loaded successfully:",
            response.length,
            "devices",
          );
          setRowList(response);
        } else {
          console.warn("⚠️ Unexpected response format:", response);
          notify(
            "error",
            "Failed to fetch devices. Unexpected response format.",
            "TOP_CENTER",
          );
          setRowList([]);
        }
      })
      .catch((error) => {
        console.error("❌ API call failed:", error);
        setShowProgressBars(false);
        setShowSkeleton(false);
        notify(
          "error",
          "Network error. Please check your connection.",
          "TOP_CENTER",
        );

        handleLogOutGlobal_PPE();
        window.location.href = "/login";

        setRowList([]);
      });
  };

  const toolbarButtonClick = (
    status: "Create" | "Edit" | "Delete",
    title,
    row?,
  ) => {
    if (status === "Delete") {
      // handleSwal(
      //   "Delete",
      //   row.original?.["name"],
      //   (resultSwal: SweetAlertResult) => {
      //     if (resultSwal.isConfirmed) {
      //       handleSwalResult(
      //         "isConfirmed",
      //         row.original?.["name"],
      //         {
      //           endpoint: `${URL_API_PPE}/v1/sites/${row.original?.["id"]}`,
      //           obj: null,
      //           body_type: "application/json",
      //           method: "DELETE",
      //           token: getValueFromLocalStorageFunc("IOT_TOKEN"),
      //         },
      //         (res) => {
      //           // setelah success hapus, maka fetching data kembali
      //           if (res?.["tipe"] == "close_after_success_save") {
      //             getDataList();
      //           }
      //         }
      //       );
      //     } else if (resultSwal.dismiss == Swal.DismissReason.cancel) {
      //       handleSwalResult("cancelled");
      //     }
      //   }
      // );
    } else {
      setModalStatus(status);
      setModalTitle(title);
      // setModalStatus('Create');
      // setModalTitle('Create User');
      setShowModal(true);

      setModalLoader(true);

      if (status === "Edit") {
        // fetch api --later
        setTimeout(() => {
          setModalLoader(false);

          setModalRow(row.original);
        }, 500);
      } else if (status === "Create") {
        setTimeout(() => {
          setModalLoader(false);
        }, 0);
      }
    }
  };

  // const handlePaginationChange = (newPage) => {
  //   console.log(newPage.pageSize);
  //   console.log(newPage.pageIndex);
  // };

  // const handlePairSubmit = async () => {
  //   if (!pairIdDevice || !pairIdUser) {
  //     toast.error("Please fill both Device ID and User ID", {
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";

  //   try {
  //     const response = await PPE_getApiSync(
  //       "http://103.41.205.40:3000/v1/device/pair",
  //       { id_device: pairIdDevice, id_user: pairIdUser },
  //       "application/json",
  //       "PUT",
  //       token
  //     );

  //     if (response?.detail === "pairing success") {
  //       toast.success("Pairing success", { position: "top-center" });
  //       setShowPairModal(false);
  //       getDataList();
  //       setPairIdDevice("");
  //       setPairIdUser("");
  //     } else {
  //       toast.error("Failed to pair device", { position: "top-center" });
  //     }
  //   } catch (error: any) {
  //     toast.error(`Error: ${error.message || "Unknown error"}`, {
  //       position: "top-center",
  //     });
  //   }
  // };

  // const handlePairSubmit = async () => {
  //   if (!pairIdDevice || !pairName) {
  //     toast.error("Please fill both Device ID and Username", {
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   // Cari id_user sesuai pairName dari userOptions
  //   const foundUser = userOptions.find(
  //     (u) => u.name.toLowerCase() === pairName.toLowerCase()
  //   );
  //   if (!foundUser) {
  //     toast.error("Username not found in user list", { position: "top-center" });
  //     return;
  //   }
  //   const idUserFromName = foundUser.id;

  //   const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
  //   const apiUrl = "https://api-kawal.savas.co.id/v1/device/pair";

  //   console.log("🚀 Pairing device:", { id_device: pairIdDevice, id_user: idUserFromName });

  //   try {
  //     const response = await PPE_getApiSync(
  //       apiUrl,
  //       { id_device: pairIdDevice, id_user: idUserFromName },
  //       "application/json",
  //       "PUT",
  //       token
  //     );

  //     console.log("📥 Pair response:", response);

  //     if (response?.detail === "pairing success") {
  //       toast.success("Pairing success", { position: "top-center" });
  //       setShowPairModal(false);
  //       getDataList();
  //       setPairIdDevice("");
  //       setPairName("");
  //     } else if (response?.statusCode) {
  //       console.error("❌ Pairing failed:", response);
  //       toast.error(response.msg || "Failed to pair device", { position: "top-center" });
  //     } else {
  //       console.warn("⚠️ Unexpected pair response:", response);
  //       toast.error("Failed to pair device", { position: "top-center" });
  //     }
  //   } catch (error: any) {
  //     console.error("❌ Pairing error:", error);
  //     toast.error(`Error: ${error.message || "Unknown error"}`, {
  //       position: "top-center",
  //     });
  //   }
  // };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MaterialReactTable
          columns={columns}
          data={rowList}
          paginationDisplayMode="pages" // pages->tampilkan per nomor halaman (1,2,3,...)
          muiPaginationProps={{
            size: "medium",
            color: "primary",
            shape: "rounded",
            variant: "outlined",
            rowsPerPageOptions: [
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 15, label: "15" },
              { value: rowList.length, label: "All" },
            ],
            // rowsPerPageOptions:[5,10,15],
            showFirstButton: true,
            showLastButton: true,
          }}
          onPaginationChange={setPagination} // harus set 'state -> pagination' juga
          // rowCount={100} //you can tell the pagination how many rows there are in your back-end data

          state={{
            pagination: pagination,
            showAlertBanner: false,
            showProgressBars: showProgressBars,
            showSkeletons: showSkeleton,
          }}
          // muiToolbarAlertBannerProps={{color:'error', children:'Network error'}}
          // positionToolbarAlertBanner='top'

          initialState={{
            // columnPinning:{left:['mrt-row-actions','mrt-row-numbers']},
            density: "comfortable", // tinggi setiap row (spacious, comfortable, compact)
            columnOrder: [
              "mrt-row-numbers",
              "full_name",
              "email",
              "is_active",
              "is_superuser",
              // 'mrt-row-actions',
            ],
            columnVisibility: { id: false, token_user: false },
          }}
          renderTopToolbarCustomActions={({ table }) => {
            const modalEventOutChange = ({ tipe, value, form }) => {
              if (form === "create") {
                if (tipe === "close_modal") {
                  // setShowModal(value);
                  setTimeout(() => {
                    setShowModal(value);
                  }, 5);
                } else if (tipe === "close_after_success_save") {
                  setShowModal(value);
                  getDataList();
                }
              }
            };

            return (
              <Box>
                <div className="d-flex gap-2 mb-2 mt-2 ms-2">
                  <Button
                    //color="success"
                    onClick={() => {
                      toolbarButtonClick("Create", "Import Data");
                    }}
                    variant="contained"
                    className="d-flex justify-content-between"
                    style={{
                      backgroundColor: "#008ea1",
                      paddingLeft: "5px",
                      paddingRight: "10px",
                    }}
                  >
                    <ControlPointRounded titleAccess="Create" />
                    <span className="ms-1" title="Create">
                      Import Data
                    </span>
                  </Button>

                  {/* Tombol Pair Device baru */}
                  <Button
                    onClick={() => setShowPairModal(true)}
                    variant="contained"
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      backgroundColor: "#008ea1",
                      paddingLeft: "5px",
                      paddingRight: "10px",
                    }}
                  >
                    <AdUnitsRounded titleAccess="Pair Device" />
                    <span className="ms-1" title="Pair Device">
                      Pair Device
                    </span>
                  </Button>

                  <Button
                    color="secondary"
                    onClick={() => {
                      getDataList();
                    }}
                    variant="outlined"
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      minWidth: "0",
                    }}
                  >
                    <Refresh titleAccess="Refresh" />
                    {/* <span className='ms-1'>Refresh</span>  */}
                  </Button>
                </div>

                <ModalImportDevice
                  par_show={showModal ?? false}
                  title={modalTitle}
                  status={modalStatus}
                  par_statusLoader={modalLoader}
                  row={modalRow}
                  outChange={modalEventOutChange}
                />

                {/* Modal Pair Device */}
                <ModalPairDevice
                  show={showPairModal}
                  setShow={setShowPairModal}
                  onSuccess={() => {
                    getDataList();
                    setPairIdDevice("");
                    setPairName("");
                  }}
                  userOptions={userOptions}
                />
              </Box>
            );
          }}
          enableFacetedValues // untuk filterVariant = 'multi-select' hanya terambil data unik otomatis
          renderToolbarInternalActions={({ table }) => {
            return (
              <Box>
                {/* <IconButton onClick={()=>window.print()}>
                              <Print />
                            </IconButton> */}
                <MrtToggleGlobalFilterButton table={table} />
                <MrtToggleFiltersButton table={table} />
                <MrtShowHideColumnsButton table={table} />
                <MrtToggleDensePaddingButton table={table} />
                <MrtToggleFullScreenButton table={table} />
              </Box>
            );
          }}
          // custom if rows empty / kosong
          renderEmptyRowsFallback={({ table }) => {
            return (
              <p
                style={{
                  margin: 0,
                  fontFamily: '"Roboto", "Helvetica", "Arial",sans-serif',
                  fontStyle: "italic",
                  letterSpacing: "0.00938em",
                  width: "100%",
                  color: "rgba(0, 0, 0, 0.6)",
                  lineHeight: "1.5",
                  textAlign: "center",
                  paddingTop: "2rem",
                  paddingBottom: "2rem",
                  fontWeight: 400,
                }}
              >
                No records to display
              </p>
            );
          }}
          muiTableBodyProps={{
            // styling body data
            sx: {
              "& tr:nth-of-type(odd) > td": {
                backgroundColor: "aliceblue",
              },
            },
          }}
          muiTableBodyCellProps={{
            // styling semua cell dalam body data
            sx: {
              // borderRight:'1px solid #e0e0e0'
            },
          }}
          // enableRowSelection

          enableTopToolbar={true}
          muiTopToolbarProps={{
            // styling top Toolbar
            sx: {
              // background:'linear-gradient(45deg, darkcyan, white)'
              boxShadow: "0px 1px 12px -7px grey inset", // shadow inset toolbar di atas
              paddingTop: "7px",
              // borderBottom:'1px solid lightgrey'
            },
          }}
          muiTableHeadCellProps={{
            // styling head cell / nama column
            sx: {
              backgroundColor: "transparent",
              textAlign: "left",
              paddingTop: "10px",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "center",
            },
          }}
          columnFilterDisplayMode="subheader"
          enableColumnFilterModes // fuzzy, contains, so on...
          enableColumnOrdering
          enableColumnResizing
          enableRowNumbers
          rowNumberDisplayMode="static" // row number follow sort or not (static = fix 1,2,3,..; original = flexible when sort 2,1,3,...)
          enableRowActions={
            getValueFromLocalStorageFunc("IOT_IS_SPUSR") !== "true"
              ? false
              : true
          }
          positionActionsColumn="first"
          displayColumnDefOptions={{
            "mrt-row-numbers": {
              // Cell: ({staticRowIndex}) => {  // menyebabkan nomor ter-reset jadi 1 setiap page berubah
              //     return <span>{(staticRowIndex??0) + 1}</span>
              // },

              visibleInShowHideMenu: true, // show this column in "show/hide columns"
              enableHiding: true, // can hide or not menu "show/hide columns"
              // ,Cell:({cell, staticRowIndex})=>{
              //     console.log(cell)
              //     return (
              //       <span>{(staticRowIndex??0) + 1}</span>
              //     )
              // }
              Header: "No",
            },
            "mrt-row-actions": {
              header: "Actions",
              size: 100,
            },
          }}
          renderRowActions={({ cell, row, table }) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let cellContent = row.original?.["name"]?.["firstName"];
            // console.log("cellContent")
            // console.log("ID : ", cell.row.id)
            // console.log("Index : ", cell.row.index)
            // console.log("Address : ", row.original?.['address'])
            return (
              <div className="d-flex align-items-center gap-2">
                <div
                  className={`${styles["ppe-icon-actions"]} ${styles["edit"]}`}
                  title="Edit"
                  onClick={() => {
                    toolbarButtonClick("Edit", "Edit Site", row);
                  }}
                >
                  <ModeEdit sx={{ fill: "mediumslateblue !important" }} />
                </div>

                <div
                  className={`${styles["ppe-icon-actions"]} ${styles["delete"]}`}
                  title="Hapus"
                  onClick={() => {
                    toolbarButtonClick("Delete", "Delete Site", row);
                  }}
                >
                  <DeleteForever sx={{ fill: "red !important" }} />
                </div>
              </div>
            );
          }}
        />
      </LocalizationProvider>

      <ToastContainer draggable pauseOnHover />
      {/* <LocalizationProvider dateAdapter={AdapterDate}  */}
    </>
  );
};

export default ListDevice;
